import { useCallback, useEffect, useState } from 'react';
import { clearInstallerData } from '../installer/pwa/offlineQueue';
import { setClientLogHeaders } from '../lib/clientLog';

const KEY = 'installer_session_token';

export function useInstallerSession() {
  const [token, setTokenState] = useState(() => localStorage.getItem(KEY));
  // Error reports name the installer server-side; logout clears it.
  useEffect(() => { setClientLogHeaders(token ? { 'X-Session-Token': token } : null); }, [token]);
  const setToken = useCallback((t) => {
    if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY);
    setTokenState(t || null);
  }, []);
  useEffect(() => {
    const onStorage = (event) => {
      if (event.key === KEY || event.key === null) setTokenState(localStorage.getItem(KEY));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  const logout = useCallback(() => {
    if (localStorage.getItem(KEY) !== token) {
      setTokenState(localStorage.getItem(KEY));
      return Promise.reject(new Error('نشست نیروی اجرایی تغییر کرد. دوباره وارد شوید.'));
    }
    setToken(null);
    return clearInstallerData();
  }, [setToken, token]);
  return { token, setToken, logout };
}
